document.addEventListener("DOMContentLoaded", () => {
  const steps = document.querySelectorAll(".form-step");
  const stepperList = document.querySelectorAll(".form-stepper-list");
  const form = document.querySelector(".u_signip_process_form");
  const emailInput = document.querySelector("#email");
  const errorEmail = document.querySelector(".u_error_email");

  if (!form) return;

  let currentStep = 1;

  // Helper function to show a specific step
  function showStep(stepNumber) {
    steps.forEach((step, index) => {
      step.style.display = index + 1 === stepNumber ? "block" : "none";
    });

    stepperList.forEach((stepper, index) => {
      if (index + 1 < stepNumber) {
        stepper.classList.add("form-stepper-completed");
        stepper.classList.remove("form-stepper-active");
      } else if (index + 1 === stepNumber) {
        stepper.classList.add("form-stepper-active");
        stepper.classList.remove("form-stepper-completed");
      } else {
        stepper.classList.remove("form-stepper-active", "form-stepper-completed");
      }
    });

    currentStep = stepNumber;
    document.querySelector(".step_start").textContent = currentStep;
  }

  // Helper function to validate email
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Automatically move to the next step when a radio button is selected
  function autoMoveToNextStep(stepNumber, nextStepNumber) {
    const radios = document.querySelectorAll(`#step-${stepNumber} input[type="radio"]`);
    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        showStep(nextStepNumber);
      });
    });
  }

  // Validate email and move to the next step
  function handleEmailValidation() {

    function goToNextWizardStep() {
        if (validateEmail(emailInput.value.trim())) {
          errorEmail.textContent = "";
          showStep(4);
        } else {
          errorEmail.textContent = "Please enter a valid email address.";
        }
    }
    emailInput.addEventListener("blur", goToNextWizardStep);
    emailInput.addEventListener("change", goToNextWizardStep);  
    emailInput.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevent form submission
            // Move to the next page or wizard step (custom logic here)
            goToNextWizardStep(); 
        }
    });
  }
  
    

  // Automatically move to the next step when both style and size are selected
  function handleStyleAndSizeSelection() {
    const styleRadios = document.querySelectorAll("#step-4 .step-style-block input[type='radio']");
    const sizeRadios = document.querySelectorAll("#step-4 .step-size-block input[type='radio']");

    function checkSelections() {
      const styleSelected = Array.from(styleRadios).some((radio) => radio.checked);
      const sizeSelected = Array.from(sizeRadios).some((radio) => radio.checked);

      if (styleSelected && sizeSelected) {
        showStep(5);
      }
    }

    styleRadios.forEach((radio) => radio.addEventListener("change", checkSelections));
    sizeRadios.forEach((radio) => radio.addEventListener("change", checkSelections));
  }

  // Handle the final step (Submit)
  function handleFormSubmission() {
    const planRadios = document.querySelectorAll("#step-5 input[type='radio']");
    planRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const selectedPlan = radio.closest(".select-running-label-inner");
        const variantDropdown = selectedPlan.querySelector(".u_pro_var");
        const selectedVariant = variantDropdown.value;

        // Ensure style and size are selected
        const selectedStyle = document.querySelector("#step-4 .step-style-block input[type='radio']:checked");
        const selectedSize = document.querySelector("#step-4 .step-size-block input[type='radio']:checked");

        if (!selectedStyle || !selectedSize) {
          alert("Please select both a style and size before proceeding.");
          return;
        }

        // Match the selected style and size with the variant
        const matchingVariant = Array.from(variantDropdown.options).find((option) => {
          const variantTitle = option.getAttribute("data-title");
          return variantTitle.includes(selectedStyle.value) && variantTitle.includes(selectedSize.value);
        });

        if (!matchingVariant) {
          alert("No matching plan found for the selected style and size.");
          return;
        }

        document.querySelector(".u_var_id_inp").value = matchingVariant.value;

        const formData = new FormData(form);
        const email = formData.get("properties[Email]");

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(Object.fromEntries(formData)),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to add product to cart.");
            }
            return response.json();
          })
          .then(() => {
            window.location.href = `/checkout${email ? `?checkout[email]=${encodeURIComponent(email)}` : ""}`;
          })
          .catch((error) => {
            console.error(error);
            alert("An error occurred while processing your request. Please try again.");
          });
      });
    });
  }

  // Handle back button navigation
  function handleBackButton() {
    const backButtons = document.querySelectorAll(".btn-navigate-form-step");
    backButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const stepNumber = parseInt(event.target.getAttribute("step_number"), 10);
        showStep(stepNumber);
      });
    });
  }

  // Initialize the form steps
  function initializeFormSteps() {
    showStep(1); // Start with the first step
    autoMoveToNextStep(1, 2); // Move from Step 1 to Step 2
    autoMoveToNextStep(2, 3); // Move from Step 2 to Step 3
    handleEmailValidation(); // Validate email and move to Step 4
    handleStyleAndSizeSelection(); // Handle style and size selection for Step 4
    handleFormSubmission(); // Automatically submit the form on Step 5 plan selection
    handleBackButton(); // Handle back button navigation
  }

  initializeFormSteps();
});